import { ApolloLink } from 'apollo-link';
import { setContext } from 'apollo-link-context';
import { WebSocketLink } from 'apollo-link-ws';
import { bytesToBase64 } from 'byte-base64';
import { SubscriptionClient } from 'subscriptions-transport-ws';
import { CsvDirective, CustomDirectivesLink } from '@indica-labs/apollo-links';
import userManager from '../../userManager';
function encodeCsv(csv) {
    var utf8 = new TextEncoder().encode(csv);
    var base64 = bytesToBase64(utf8);
    return "data:text/csv;base64,".concat(base64);
}
function downloadCsv(csv, filename) {
    var dataUri = encodeCsv(csv);
    var linkElement = document.createElement('a');
    linkElement.download = filename;
    linkElement.href = dataUri;
    linkElement.click();
}
var directivesLink = new CustomDirectivesLink([
    new CsvDirective(downloadCsv),
]);
export function getToken() {
    return userManager.getUser()
        .then(function (user) {
        var localToken = sessionStorage.getItem('authnToken');
        if (user) {
            return user.access_token;
        }
        else if (localToken) {
            return localToken;
        }
        else {
            return null;
        }
    });
}
var wsScheme = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
var wsUri = "".concat(wsScheme, "//").concat(window.location.host, "/graphql");
var link = ApolloLink.from([
    directivesLink,
    // without this CustomDirectivesLink hits a missing "flatMap" method
    // on the "observable" returned from WebSocketLink.forward
    setContext(function (operation, ctx) { return ctx; }),
    new WebSocketLink(new SubscriptionClient(wsUri, {
        timeout: 20000,
        reconnect: true,
        lazy: true,
        connectionParams: function () { return getToken()
            .then(function (authToken) { return authToken ? { authToken: authToken } : {}; }); },
    })),
]);
export var createApolloLink = function (session) { return ({ link: link }); };
